import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DashValidation } from 'dash-common';
import {
  Box,
  Flex,
  Form,
  FormContext,
  GoogleAutocomplete,
  InputNumber,
  Slider,
  useGoogleApiLoader,
} from 'dash-ui';

import { FormFields } from 'pages/brokers/BrokerDetailsPage/BrokerDetailsPage.constants';

const LocationSection = () => {
  const { t } = useTranslation('forms');
  const { stateHandlers, formState } = useContext(FormContext);
  const [defaultViewValue, setDefaultViewValue] = useState('');
  const isGoogleApiReady = useGoogleApiLoader();
  // FIXME: re-check
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const geocoder = isGoogleApiReady ? new google.maps.Geocoder() : null;

  const onPlaceSelected = (place: google.maps.places.PlaceResult) => {
    stateHandlers[FormFields.Place]({
      placeId: place.place_id,
      lat: place.geometry?.location?.lat(),
      lng: place.geometry?.location?.lng(),
      ...place,
    });
  };

  useEffect(() => {
    if (formState.place && geocoder) {
      geocoder.geocode({ placeId: formState.place.placeId }, (result) => {
        if (result?.length) {
          setDefaultViewValue(result[0].formatted_address);
        }
      });
    }
  }, [geocoder, formState.place]);

  return (
    <Flex mb={4} alignItems="center">
      <Form.Group w="100%">
        <Form.Label>{t('forms:labels.marketArea')}</Form.Label>
        {isGoogleApiReady && (
          <GoogleAutocomplete
            defaultValue={defaultViewValue}
            placeholder={t('forms:placeholders.address') || ''}
            onPlaceSelected={onPlaceSelected}
          />
        )}
      </Form.Group>
      <Form.Group w="100%" mx={3.5}>
        <Form.Label>{t('labels.radius')}</Form.Label>
        <InputNumber
          value={formState.radius || DashValidation.DefaultLocationRadius}
          maskOptions={{
            prefix: '',
            suffix: ` ${t('common:labels:miles')}` || '',
            includeThousandsSeparator: false,
            allowDecimal: false,
          }}
          onChangeValue={(value) => stateHandlers[FormFields.Radius](value)}
          onBlur={(e) => {
            const value = Number(
              e.target.value.replace(` ${t('common:labels:miles')}`, '')
            );
            if (value < DashValidation.MinLocationRadius) {
              stateHandlers[FormFields.Radius](
                DashValidation.MinLocationRadius
              );
            }
            if (value > DashValidation.MaxLocationRadius) {
              stateHandlers[FormFields.Radius](
                DashValidation.MaxLocationRadius
              );
            }
          }}
        />
      </Form.Group>
      <Box w="100%" mt={4}>
        <Slider
          min={DashValidation.MinLocationRadius}
          max={DashValidation.MaxLocationRadius}
          value={formState.radius || DashValidation.DefaultLocationRadius}
          defaultValue={DashValidation.DefaultLocationRadius}
          onChange={(value) => stateHandlers[FormFields.Radius](value)}
        />
      </Box>
    </Flex>
  );
};

export default LocationSection;
